import { SideNav, SideNavItem, Icon } from '@amzn/storm-ui';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AMAZON_NAV_INKWELL } from '../../constants/commonConstants';

export const StyledSideNav = styled(SideNav)`
  background-color: ${AMAZON_NAV_INKWELL};
  min-height: 100vh;
  height: auto;
  flex-shrink: 0;
  width: auto;

  > button {
    color: ${({ theme }) => theme.color.gray[50]};
    background-color: ${AMAZON_NAV_INKWELL};

    &:hover {
      background-color: ${({ theme }) => theme.color.gray[600]};
    }

    svg {
      color: ${({ theme }) => theme.color.gray[50]};
    }
  }
`;

export const StyledSideNavItem = styled(SideNavItem)<{ isActive?: boolean }>`
  background-color: ${AMAZON_NAV_INKWELL};
  border-left: 0.1875rem solid transparent;
  transition: background-color 0.5s ease;

  &&,
  && span,
  && div {
    color: ${({ theme }) => theme.color.gray[50]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[600]};
  }

  ${({ isActive, theme }) =>
    isActive &&
    `
    background-color: ${theme.color.gray[700]};
    border-left: 0.1875rem solid ${theme.color.clementine[500]};
  `}
`;

export const StyledLink = styled(Link)<{ $disabled?: boolean }>`
  &&,
  &&:visited,
  &&:hover,
  &&:active {
    text-decoration: none;
    display: block;
    color: ${({ theme }) => theme.color.gray[50]};
  }

  & * {
    color: ${({ theme }) => theme.color.gray[50]};
  }

  &:focus {
    outline: 0.125rem solid ${({ theme }) => theme.color.blue[500]};
    outline-offset: -0.125rem;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    pointer-events: none;
    opacity: 0.5;
  `}
`;

export const StyledIcon = styled(Icon)`
  vertical-align: middle;
  color: ${({ theme }) => theme.color.gray[50]};
`;

export const DropDownIcon = styled(Icon)`
  margin-left: 4.5rem;
  color: ${({ theme }) => theme.color.gray[50]};
`;
